/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SetRecipientSettings } from './set-recipient-settings';


export interface SetRecipientSettingsRequest { 
    setRecipientSettings?: Array<SetRecipientSettings> | null;
}

